<template>
  <v-stepper v-model="itemActive" vertical non-linear class="tabsStepper">
    <v-layout wrap align-start justify-start fill-height row>
      <v-flex class="tabs ">
        <v-text-field v-model="searchText" solo-inverted hide-details clearable
                      prepend-inner-icon="search" label="Buscar persona" class="small-control square my-0 py-0"
        />

        <v-stepper-step v-for="(persona, index) in personasContactoSearch" :key="index" :step="index" editable class="">
          <div class="persona-descripcion">
            <span class="subheading">
              {{ persona.Nombre }}
            </span>
            <span v-if="persona.Cargo" class="body-1">
              {{ persona.Cargo }}
            </span>
          </div>
          <span v-if="persona.CorreoElectronico" class="body-1">
            {{ persona.CorreoElectronico }}
          </span>
        </v-stepper-step>
      </v-flex>

      <v-flex class="items " style="overflow-y: auto;">
        <v-stepper-content v-for="(persona, index) in personasContactoSearch" :key="index" :step="index">
          <v-card :class="classSteep">
            <copy-chip :text="persona.CorreoElectronico" class="subheading ml-0 mb-3" />
            <div class="description mb-4">
              <div v-if="persona.Nombre">
                Nombre: {{ persona.Nombre }}
              </div>
              <div v-if="persona.Cargo">
                Cargo: {{ persona.Cargo }}
              </div>
              <div v-if="persona.Fax">
                Fax: {{ persona.Fax }}
              </div>
              <!-- <div v-if="persona.NotificacionBoletin">NotificacionBoletin: {{ persona.NotificacionBoletin }}</div> -->
              <v-layout v-if="persona.TelefonoTrabajo" class="mt-2" align-center justify-start>
                <div>Telefono Trabajo: {{ persona.TelefonoTrabajo }}</div>
                <v-flex class="ml-2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn :href="`aocphone:0${ persona.TelefonoTrabajo.replace(/ |-/g, '') }`" target="_parent"
                             color="green" class="btn-dense"
                             fab dark icon small @click="sleepAskToLeave"
                      >
                        <v-icon dark>
                          phone
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ persona.TelefonoTrabajo }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout v-if="persona.TelefonoParticular" class="mt-2" align-center justify-start>
                <div>Telefono Particular: {{ persona.TelefonoParticular }}</div>
                <v-flex class="ml-2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn :href="`aocphone:0${ persona.TelefonoParticular.replace(/ |-/g, '') }`" target="_parent"
                             color="green" class="btn-dense"
                             fab dark icon small @click="sleepAskToLeave"
                      >
                        <v-icon dark>
                          phone
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ persona.TelefonoParticular }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout v-if="persona.MovilTrabajo" class="mt-2" align-center justify-start>
                <div>Movil Trabajo: {{ persona.MovilTrabajo }}</div>
                <v-flex class="ml-2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn :href="`aocphone:0${ persona.MovilTrabajo.replace(/ |-/g, '') }`" target="_parent"
                             color="green" class="btn-dense"
                             fab dark icon small @click="sleepAskToLeave"
                      >
                        <v-icon dark>
                          phone
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ persona.MovilTrabajo }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout v-if="persona.MovilParticular" class="mt-2" align-center justify-start>
                <div>Movil Particular: {{ persona.MovilParticular }}</div>
                <v-flex class="ml-2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn :href="`aocphone:0${ persona.MovilParticular.replace(/ |-/g, '') }`" target="_parent"
                             color="green" class="btn-dense"
                             fab dark icon small @click="sleepAskToLeave"
                      >
                        <v-icon dark>
                          phone
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ persona.MovilParticular }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <span v-html="persona.Observaciones" />
            </div>
          </v-card>
        </v-stepper-content>
      </v-flex>

      <inner-loading :visible="loading" />
    </v-layout>
  </v-stepper>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import CopyChip from '@/components/CopyChip'
import { Entities } from 'mixins/index.js'

export default {
  name: 'Pesonas',
  components: { CopyChip, InnerLoading },
  mixins: [ Entities ],
  props: {
    cliente: {
      type: [String, Number],
      default: '0'
    },
    instalacion: {
      type: [String, Number],
      default: '0'
    }
  },
  data () {
    return {
      loading: false,
      classSteep: 'pa-3 back',
      personasContacto: [],
      tabActive: null,
      itemActive: 'n',
      searchText: null
    }
  },
  computed: {
    personasContactoSearch () {
      if (this.searchText) {
        let text = this.searchText.toLowerCase()
        return this.personasContacto.filter(obj => {
          return (obj.Nombre && obj.Nombre.toLowerCase().includes(text)) ||
          (obj.CorreoElectronico && obj.CorreoElectronico.toLowerCase().includes(text))
        })
      } else return this.personasContacto
    }
  },
  methods: {
    sleepAskToLeave () {
      let AskToLeave = this.$store.state.askToLeave
      this.$store.dispatch('AskToLeave', false)
      setTimeout(() => {
        this.$store.dispatch('AskToLeave', AskToLeave)
      }, 750)
    },
    clearn () {
      this.personasContacto = []
    },
    load (cliente, instalacion) {
      this.personasContacto = []
      if (cliente && instalacion) {
        this.loading = true
        this.itemActive = 'x'
        this.axios.get(`${this.$apiUrl('personaContacto')}?cliente=${cliente}&instalacion=${instalacion}`,
          { headers: { 'Content-Type': 'application/json' } })
          .then(({ data }) => {
            if (data && data.data) {
              this.personasContacto = data.data
              this.$nextTick(() => {
                this.itemActive = this.personasContacto[0].NumeroOrden
              })
            }
          })
          .catch(() => { })
          .then(() => { this.loading = false })
      }
    }
  }
}
</script>
